// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root_pQXfr{margin:10px 15px 15px;font-family:ProximaNova,sans-serif}.container_QoZ2d{position:relative;align-items:center;background:#f9f9f9;padding:11px 15px}.container_QoZ2d,.rewardsIcon_zw2eI{display:flex}.rewardsIcon_zw2eI img{width:24px;max-height:24px}.rewardsMessage_pt\\+MV{display:flex;margin-left:20px}.rewardsMessage_pt\\+MV a{position:relative;font-size:14px;line-height:20px;font-weight:400;color:#000;text-decoration:none}.rewardsMessage_pt\\+MV a:after{content:\"\";width:100%;position:absolute;left:0;bottom:0;border-width:0 0 1px;border-style:solid}", ""]);
// Exports
exports.locals = {
	"root": "root_pQXfr",
	"container": "container_QoZ2d",
	"rewardsIcon": "rewardsIcon_zw2eI",
	"rewardsMessage": "rewardsMessage_pt+MV"
};
module.exports = exports;
